import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  standardColours,
  brandColours,
  fontSize,
  fontWeights,
  visuallyHidden,
} from '../styles';
import { Link, Svg } from './ui';
import phoneIcon from '../images/phone-icon.inline.svg';
import fileUploadIcon from '../images/file-upload-icon.inline.svg';

const StyledPhoneArtworkIconLinks = styled.ul`
  display: flex;
  align-items: center;

  ${maxBreakpointQuery.large`
    justify-content: center;
  `}

  ${({ $isNav }) => {
    if ($isNav) {
      return css`
        ${minBreakpointQuery.large`
          ${visuallyHidden()};
        `}
      `;
    }
  }}
`;

const StyledItem = styled.li`
  &:nth-child(2) {
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid ${standardColours.grey};

    ${minBreakpointQuery.xxlarge`
      margin-left: 15px;
      padding-left: 15px;
    `}

    ${minBreakpointQuery.xxxxlarge`
      margin-left: 20px;
      padding-left: 20px;
    `}
  }

  ${({ $isHeaderArtwork }) => {
    if ($isHeaderArtwork) {
      return css`
        ${maxBreakpointQuery.large`
          ${visuallyHidden()};
        `}
      `;
    }
  }}
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${brandColours.primary};
  font-weight: ${fontWeights.semibold};
  white-space: nowrap;

  ${minBreakpointQuery.xxlarge`
    ${fontSize(18)};
  `}
`;

const StyledIcon = styled(Svg)`
  display: block;
  height: 22px;
  width: 22px;

  ${minBreakpointQuery.large`
    position: relative;
    top: 1px;
  `}
`;

const StyledText = styled.span`
  ${({ $isHeader }) => {
    if ($isHeader) {
      return css`
        ${maxBreakpointQuery.large`
          ${visuallyHidden()};
        `}
      `;
    }
  }}
`;

const PhoneArtworkIconLinks = ({ isHeader, isNav }) => {
  const {
    datoCmsHeader: { artworkLink },
    datoCmsContactInformation: { phoneNumber },
  } = useStaticQuery(graphql`
    query NavigationIconQuery {
      datoCmsHeader {
        artworkLink {
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      datoCmsContactInformation {
        phoneNumber
      }
    }
  `);

  return (
    <StyledPhoneArtworkIconLinks $isNav={isNav}>
      <StyledItem>
        <StyledLink as="a" href={`tel:${phoneNumber}`}>
          <StyledIcon image={phoneIcon} />
          <StyledText $isHeader={isHeader}>{phoneNumber}</StyledText>
        </StyledLink>
      </StyledItem>
      <StyledItem $isHeaderArtwork={isHeader}>
        <StyledLink to={artworkLink.pageUrl}>
          <StyledIcon image={fileUploadIcon} />
          <StyledText $isHeader={isHeader}>Upload Artwork</StyledText>
        </StyledLink>
      </StyledItem>
    </StyledPhoneArtworkIconLinks>
  );
};

export default PhoneArtworkIconLinks;
